import CachedLazy from '../../../../../components/CachedLazy/CachedLazy';

export default CachedLazy(() => import('./DnaKitRegister'));
